export default function Home(){

    return (
        <div className="pageContainer">
            <div className="card">
                <h1 className="pageTitle">홈 페이지</h1>
                <p>환영합니다! 투자72에 오신 것을 환영합니다.</p>
            </div>
        </div>
    );
}